import { DockviewApi } from 'dockview';
import { TabContext } from '@/entities/tab/model/tab.types';
import { useEffect, useState } from 'react';
import { usePanelChange } from './usePanelChange';

export function useFocusedTab(api: DockviewApi | null): TabContext | null {
  const [activePanelId, setActivePanelId] = useState<string | null>(null);

  useEffect(() => {
    if (!api) {
      setActivePanelId(null);
      return;
    }

    const activePanel = api.activePanel;
    setActivePanelId(activePanel?.id || null);

    const disposable = api.onDidActivePanelChange((panel) => {
      console.log('focus', panel);
      setActivePanelId(panel?.id || null);
    });

    return () => {
      disposable.dispose();
    };
  }, [api]);

  return usePanelChange(api, activePanelId);
}
